module.exports = "<div\n\tclass=\"icon-user-avatar\"\n\t[style.background-image]=\"profilePhoto ? 'url(' + profilePhoto + ')' : ''\"\n>{{ elementStyle }}</div>"


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/user-avatar/user-avatar.html
// module id = ../../../../../src/app/components/user-avatar/user-avatar.html
// module chunks = 1